import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import PracticeAreas from "@/pages/PracticeAreas";
import PracticeAreaDetail from "@/pages/PracticeAreaDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Disclaimer from "@/pages/Disclaimer";

import AdminLogin from "@/pages/admin/AdminLogin";
import { ProtectedRoute } from "@/pages/admin/ProtectedRoute";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminProfile from "@/pages/admin/AdminProfile";
import AdminPracticeAreas from "@/pages/admin/AdminPracticeAreas";
import AdminBlogList from "@/pages/admin/AdminBlogList";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminContact from "@/pages/admin/AdminContact";
import AdminSEO from "@/pages/admin/AdminSEO";
import AdminSocial from "@/pages/admin/AdminSocial";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/practice-areas" element={<PracticeAreas />} />
              <Route path="/practice-areas/:id" element={<PracticeAreaDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/disclaimer" element={<Disclaimer />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="homepage" element={<AdminHomepage />} />
                <Route path="profile" element={<AdminProfile />} />
                <Route path="practice-areas" element={<AdminPracticeAreas />} />
                <Route path="blog" element={<AdminBlogList />} />
                <Route path="blog/new" element={<AdminBlogEditor />} />
                <Route path="blog/:id" element={<AdminBlogEditor />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="media" element={<AdminMedia />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
                <Route path="contact" element={<AdminContact />} />
                <Route path="seo" element={<AdminSEO />} />
                <Route path="social" element={<AdminSocial />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
